import { useEffect } from 'react'
import Cookies from 'js-cookie'
import { useRouter } from 'next/router'
import axios from 'axios'
import { loggerClient } from '../utils/loggerClient'
import { camelCaseKeys } from '../utils/object'

const COGNITO_SUB = 'hm.originations.authentication.cognitoSub'
const BORROWER_ID = 'hm.originations.authentication.borrowerId'
const CUSTOMER_ID = 'hm.originations.authentication.customerId'

const useProcessAttributions = () => {
  const router = useRouter()

  useEffect(() => {
    const processAttributions = async () => {
      // Just to ensure that the router is ready at client side before accessing the query
      if (router.isReady) {
        const { applicationId, ...queryParams } = router.query || {}
        const parsedQueryData = camelCaseKeys(queryParams)
        const payload = {
          ...parsedQueryData,
          pvid: Cookies.get('pvid'),
          // eslint-disable-next-line no-undef
          referredFrom: document.referrer,
          // eslint-disable-next-line no-undef
          url: window.location.href,
          ajsAnonymousId: Cookies.get('ajs_anonymous_id'),
          losBorrowerId: Cookies.get(BORROWER_ID),
          lmsCustomerId: Cookies.get(CUSTOMER_ID),
          subscriberId: Cookies.get(COGNITO_SUB),
          losApplicationId: applicationId,
        }
        try {
          const processAttributionsURL = `${ process.env.NEXT_PUBLIC_HM_APPLY_BFF_URI }/no-auth/attributions`
          const result = await axios.post(processAttributionsURL, payload)
          loggerClient.info('Attributions saved', {
            result: result?.data,
          })
        } catch (error) {
          loggerClient.error('Attributions processing failed', {
            error,
          })
        }
      }
    }
    processAttributions()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router?.isReady])

  return null
}

export default useProcessAttributions
